"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROVIDED_CONFIGURATIONS = void 0;
var menuItemConfig_1 = __importDefault(require("../menuItemConfig"));
var category_1 = __importDefault(require("./category"));
var coupon_1 = __importDefault(require("./coupon"));
var item_1 = __importDefault(require("./item"));
var menu_1 = __importDefault(require("./menu"));
var modifier_1 = __importDefault(require("./modifier"));
var modifierSet_1 = __importDefault(require("./modifierSet"));
var allConfigurations = {
    Category: category_1.default,
    Coupon: coupon_1.default,
    Item: item_1.default,
    Menu: menu_1.default,
    Modifier: modifier_1.default,
    ModifierSet: modifierSet_1.default,
};
exports.PROVIDED_CONFIGURATIONS = {
    Category: category_1.default.config,
    Coupon: coupon_1.default.config,
    Item: item_1.default.config,
    Menu: menu_1.default.config,
    Modifier: modifier_1.default.config,
    ModifierSet: modifierSet_1.default.config,
};
exports.default = {
    Category: new menuItemConfig_1.default(category_1.default, allConfigurations),
    Coupon: new menuItemConfig_1.default(coupon_1.default, allConfigurations),
    Item: new menuItemConfig_1.default(item_1.default, allConfigurations),
    Menu: new menuItemConfig_1.default(menu_1.default, allConfigurations),
    Modifier: new menuItemConfig_1.default(modifier_1.default, allConfigurations),
    ModifierSet: new menuItemConfig_1.default(modifierSet_1.default, allConfigurations),
};
//# sourceMappingURL=index.js.map